import { render, staticRenderFns } from "./kEditor.vue?vue&type=template&id=baaf6f60&scoped=true&"
import script from "./kEditor.vue?vue&type=script&lang=js&"
export * from "./kEditor.vue?vue&type=script&lang=js&"
import style0 from "./kEditor.vue?vue&type=style&index=0&id=baaf6f60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baaf6f60",
  null
  
)

export default component.exports